(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flash-sales-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(n){return n<10?'0'+n:''+n}
  function cell(label,val){return '<span class="t-grp"><span class="t-cell">'+val+'</span><span class="t-lbl">'+label+'</span></span>';}
  function sep(){return '<span class="t-sep">:</span>';}
  function fmtDelta(ms){
    if(ms<=0)return '<span class="t-cell">SCADUTO</span>';
    var t=Math.floor(ms/1000),d=Math.floor(t/86400),h=Math.floor((t%86400)/3600),m=Math.floor((t%3600)/60),s=t%60;
    if(d>0) return cell('GG',pad(d))+sep()+cell('ORE',pad(h))+sep()+cell('MIN',pad(m));
    if(h>0) return cell('ORE',pad(h))+sep()+cell('MIN',pad(m))+sep()+cell('SEC',pad(s));
    return cell('MIN',pad(m))+sep()+cell('SEC',pad(s));
  }
  function tick(){
    document.querySelectorAll('.fs-card[data-end]').forEach(function(c){
      var end=new Date(c.getAttribute('data-end')).getTime(),d=end-Date.now();
      var t=c.querySelector('[data-timer]');
      if(t){t.innerHTML=fmtDelta(d);t.classList.toggle('urgent',d>0&&d<24*3600*1000)}
    });
  }
  tick();setInterval(tick,1000);

  // Frecce slider grid card brand
  document.querySelectorAll('.fs-grid-wrap').forEach(function(wrap){
    var grid = wrap.querySelector('[data-grid]');
    var prev = wrap.querySelector('[data-grid-prev]');
    var next = wrap.querySelector('[data-grid-next]');
    if(!grid || !prev || !next) return;
    function gupdate(){
      var max = grid.scrollWidth - grid.clientWidth - 2;
      prev.toggleAttribute('disabled', grid.scrollLeft <= 2);
      next.toggleAttribute('disabled', grid.scrollLeft >= max);
    }
    function gnudge(dir){
      var amt = grid.clientWidth * 0.7 * dir;
      grid.scrollBy({left: amt, behavior: 'smooth'});
    }
    prev.addEventListener('click', function(){gnudge(-1)});
    next.addEventListener('click', function(){gnudge(1)});
    grid.addEventListener('scroll', gupdate, {passive:true});
    window.addEventListener('resize', gupdate);
    gupdate();
  });

  // Frecce strip aggregata
  document.querySelectorAll('.fs-strip-wrap').forEach(function(wrap){
    var strip = wrap.querySelector('[data-strip]');
    var prev = wrap.querySelector('[data-strip-prev]');
    var next = wrap.querySelector('[data-strip-next]');
    if(!strip || !prev || !next) return;
    function update(){
      var max = strip.scrollWidth - strip.clientWidth - 2;
      prev.toggleAttribute('disabled', strip.scrollLeft <= 2);
      next.toggleAttribute('disabled', strip.scrollLeft >= max);
    }
    function nudge(dir){
      var amt = strip.clientWidth * 0.75 * dir;
      strip.scrollBy({left: amt, behavior: 'smooth'});
    }
    prev.addEventListener('click', function(){nudge(-1)});
    next.addEventListener('click', function(){nudge(1)});
    strip.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-editorial-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.ed-cat-grid, .ed-cat-grid > .ed-cat').forEach(function(el){
      el.classList.add('is-visible');
    });
    return;
  }
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        // Anche il grid parent per attivare hub e cross coral
        var grid = e.target.closest('.ed-cat-grid');
        if (grid) grid.classList.add('is-visible');
        obs.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  document.querySelectorAll('.ed-cat-grid > .ed-cat, .ed-cat-info__pills').forEach(function(el){
    obs.observe(el);
  });

  // ===== Best sellers coverflow 3D (supporta N prodotti, mostra ±2 visibili) =====
  document.querySelectorAll('[data-coverflow]').forEach(function(cv){
    var stage = cv.querySelector('[data-cv-stage]');
    var items = stage ? stage.querySelectorAll('.cv-item') : [];
    var prev = cv.querySelector('[data-cv-prev]');
    var next = cv.querySelector('[data-cv-next]');
    var current = cv.querySelector('[data-cv-current]');
    if (!items.length) return;
    var center = 0;
    var n = items.length;

    function update(){
      items.forEach(function(item, i){
        var rel = i - center;
        if (rel > n / 2) rel -= n;
        if (rel < -(n / 2)) rel += n;
        if (rel >= -2 && rel <= 2) {
          item.dataset.pos = rel;
        } else {
          item.dataset.pos = 'hidden';
        }
      });
      if (current) {
        current.textContent = String(center + 1).padStart(2, '0');
      }
    }
    function go(idx){
      center = ((idx % n) + n) % n;
      update();
    }
    update();

    if (prev) prev.addEventListener('click', function(){ go(center - 1); });
    if (next) next.addEventListener('click', function(){ go(center + 1); });
    items.forEach(function(item, i){
      item.addEventListener('click', function(e){
        if (parseInt(item.dataset.pos,10) !== 0) {
          e.preventDefault();
          go(i);
        }
      });
    });
    // Keyboard
    cv.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft') go(center - 1);
      if (e.key === 'ArrowRight') go(center + 1);
    });
  });

  // ===== Trending brand strip scroll arrows =====
  document.querySelectorAll('[data-trending-strip]').forEach(function(strip){
    var track = strip.querySelector('[data-trending-track]');
    var prev = strip.querySelector('[data-trending-prev]');
    var next = strip.querySelector('[data-trending-next]');
    if (!track || !prev || !next) return;

    var scrollAmount = function(){
      var firstProd = track.querySelector('.ed-trending__prod');
      if (!firstProd) return 240;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 10);
      return firstProd.getBoundingClientRect().width + gap;
    };

    var updateArrows = function(){
      var max = track.scrollWidth - track.clientWidth - 4;
      prev.hidden = track.scrollLeft <= 4;
      next.hidden = track.scrollLeft >= max || max <= 0;
    };
    updateArrows();
    track.addEventListener('scroll', updateArrows, {passive:true});
    window.addEventListener('resize', updateArrows);

    prev.addEventListener('click', function(){
      track.scrollBy({left: -scrollAmount() * 2, behavior:'smooth'});
    });
    next.addEventListener('click', function(){
      track.scrollBy({left: scrollAmount() * 2, behavior:'smooth'});
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
